<template>
    <div class="m-main-box">
        <Menu :logoUrl="foot.logoUrl" :menus="menus"></Menu>
        <Banner :list="bannerList" :height="186" :showCover="true" :showBtn="true"></Banner>

        <Banner :list="headList" :height="25" :showBtn="false" class="head-banner"></Banner>

        <router-view>
        </router-view>

        <Footer :foot="foot" :qrcodeList="qrcodeList"></Footer>
    </div>
</template>

<script>

import Banner from "../components/MobileBanner"
import Menu from "../components/MobileMenu"
import Footer from "../components/MobileFooter"
import Content from "../pages/MobileContent"
import Beian from "../components/Beian"

export default {
    name:"Content",
    components:{
        Banner, Menu, Content, Footer, Beian
    },data(){
        return {
            bannerList:[],
            headList:[],
            bulletList:[],
            foot:[],
            menus:[],
            qrcodeList:[]
        }
    },
    mounted(){
        this.getMenus();
        this.getHeaders();
        this.getBanners();
        this.getFooter();
        this.getQrcodeList();
    },
    methods:{
        getMenus(){
            const self = this;
            this.$http.get("/bicycle/inter/menus").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.menus = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getHeaders(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=6").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.headList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getBanners(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=0").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getQrcodeList(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=7").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.qrcodeList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getFooter(){
            const self = this;
            this.$http.get("/bicycle/inter/footer").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.foot = res.data.data;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>
.m-main-box{
    width: 100%;
    background: white;
    overflow: auto;
    height: 100%;
}
.head-banner{
    margin-top: 5px;
}
.index-line{
    width: 100%;
    height: 6px;
}
.middle-pic{
    height: 70px;
}
.middle-pic img{
    height: 70px;width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileIndex.vue